import NavigationRequests from "../../../../../../../visComponents/navigation/navigationRequests";
import PropTypes from "prop-types";
import {COUNTERTOP_GROUP} from "../../../../../../../kvComponent/core/constants";
import {connect} from "react-redux";
import {SqftOptionsLoading} from "./SqftOptionsLoading";
import React from "react";

class SqftFeaturesChecker extends NavigationRequests {

  static propTypes = {
    subPart: PropTypes.object.isRequired,
    callBack: PropTypes.func,
    withFiltersRequest: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this._filtersRequestsMade = [];
  }

  componentDidMount() {
    const {subPart, callBack, withFiltersRequest, filterGroups} = this.props;
    let checkSubPart = subPart.part ? subPart : {part: subPart}
    if (withFiltersRequest && !this._filtersRequestsMade.includes(checkSubPart.partId) && COUNTERTOP_GROUP.includes(checkSubPart.partId)
      && !checkSubPart.filtersReceived) {
      this._filtersRequestsMade.push(checkSubPart.partId);
      this.checkIfAllFiltersReceived(checkSubPart, filterGroups)
        .then(() => {
          if (callBack) {
            callBack()
          }
        });
    }
    this.checkIfAllFeaturesReceived(checkSubPart, "", callBack);
  }

  render() {
    return <SqftOptionsLoading windowHeight={this.props.windowHeight} isMobile={this.props.isMobile}/>
  }
}

const mapStateToProps = (store) => {
  const {windowHeight, isMobile} = store.serverState;

  return {
    cartItems: store.cartState.cartItems,
    filterGroups: store.filterState.filterGroups,
    windowHeight,
    isMobile,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesChecker);
